import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  PagingResponseModel,
} from "../shared";
import { RateEventContainerModel } from "../../../../../models/aggregates/pgw/rate-event.model";
import { RateEventQueryCriteriaClass, RateEventCriteriaModelQuery } from "../../criteria/pgw/rate-event-criteria.model";

@Injectable({
  providedIn: "root",
})
export class RateEventService extends BaseApiTemplateService<RateEventContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "merchant/rate-events";
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.PGW_PREFIX + "merchant/rate-events";
    this.httpClient = http;
  }

  getRateChargeByCriteria(
    visa: ApiVisa,
    criteria?: RateEventQueryCriteriaClass
  ): Observable<PagingResponseModel<RateEventContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildRateEventCriteria = new RateEventCriteriaModelQuery(criteria);
    console.log("query", buildRateEventCriteria.query);
    return this.httpClient.get<PagingResponseModel<RateEventContainerModel>>(
      this.apiUrl + "/query?" + buildRateEventCriteria.query,
      this.getHttpHeader(visa)
    );
  }
}
